import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import Marquee from "../components/landing/Marquee";
import Services from "../components/landing/Services";
import Work from "../components/landing/Work";
import Process from "../components/landing/Process";
import ContactSection from "../components/landing/ContactSection";
import Footer from "../components/landing/Footer";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
    return () => lenis.destroy();
  }, []);

  return (
    <div className="bg-obsidian min-h-screen text-slate-50" data-testid="landing-page">
      <div className="noise-overlay" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Work />
        <Process />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
